import * as React from 'react';
import {Box} from "@mui/material";

export default function Rules() {
    return (
        <Box className='page-main-box'>
            <table data-number-column="false" >
                <tbody>
                <tr className={"table-header"}>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="4"><span
                            className="fabric-text-color-mark" data-renderer-mark="true">Question</span></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="14"><span
                            className="fabric-text-color-mark" data-renderer-mark="true">Answer</span></p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="88">User location assignment</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <ul className="ak-ul" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="125">Each country has its own list of products available
                                    in the shop, based on the specifics of the region.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="219">On your first login to your personal account, your
                                    employment location is automatically pulled from People Force.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="326">If necessary, the location can be changed.</p>
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="375">How to <strong data-renderer-mark="true"><u
                            data-renderer-mark="true">place an order</u></strong>?</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="398">To place an order, you need to:</p>
                        <ul className="ak-ul" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="436">Choose the location where you want to pick up your order</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="491">Choose a product available in that location</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="539">Open the product page</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="569">Choose a size (if applicable)</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="604">Proceed to checkout.</p>
                            </li>
                        </ul>
                        <p data-renderer-start-pos="630">If the product is <strong data-renderer-mark="true">in
                            stock</strong>, the quantity available for ordering will be shown when placing the order.</p>
                        <p data-renderer-start-pos="730">If the product is <strong data-renderer-mark="true">out of
                            stock</strong>, a corresponding notification will appear. In that case you can still place
                            a made-to-order request, but keep in mind that production and delivery will take a longer
                            period of time (<strong data-renderer-mark="true">2-3 months instead of 1-2; does not apply
                                to electronics</strong>).</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="994">How to <strong data-renderer-mark="true"><u
                            data-renderer-mark="true">give a gift?</u></strong></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="1018">A gift is placed the same way as a regular
                            order, except that instead of the <strong
                                data-renderer-mark="true">&ldquo;place order&rdquo;</strong> button you need to click
                            the <strong data-renderer-mark="true">&ldquo;gift&rdquo;</strong> button.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="1159">What is the<strong data-renderer-mark="true"> <u
                            data-renderer-mark="true">order processing flow (for yourself or as a gift) for
                            branded merchandise?</u></strong></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <ul className="ak-ul" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="1256">The order is automatically turned into an Asana task
                                    and enters the system for further processing.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="1355">Once processing begins, the task will get
                                    the <strong data-renderer-mark="true">&ldquo;in progress&rdquo;</strong> status.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="1431">If the task contains incorrect data or any
                                    additions/changes are needed, everything is discussed in the comments of that
                                    task.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="1569">At this stage it is also determined whether the
                                    product needs to be manufactured, or the availability of the ordered product in
                                    stock is confirmed.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="1709">Next, the order task is reassigned to the office
                                    manager in Lithuania.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="1782">Once the product is ready for pickup (Lithuania)
                                    or for shipping (other locations), the task will get the&nbsp; <strong
                                        data-renderer-mark="true">&ldquo;delivery&rdquo;</strong> status.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="1912">The task is then transferred to the ordering employee
                                    (for address delivery), or to the location's office manager (for office delivery).</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="2043">When the parcel arrives at the office, the office
                                    manager notes in the corresponding task that the order is ready for pickup, and
                                    transfers the task to the person who ordered the product (or to the employee
                                    receiving the gift, in the case of gifting).</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="2255">After the product is handed over to the employee,
                                    the office manager moves the task to the <strong
                                        data-renderer-mark="true">&ldquo;done&ldquo; section</strong> and leaves a
                                    corresponding comment in the task.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="2389">After receiving the product, the ordering employee
                                    (or the employee receiving the gift, in the case of gifting) confirms it from their
                                    personal account in Belcoin Shop. The bot then automatically closes the task for the ordered product.</p>
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="2606">What is the<strong data-renderer-mark="true"> <u
                            data-renderer-mark="true">order processing flow (for yourself or as a gift) for
                            electronics?</u></strong></p>
                        <p data-renderer-start-pos="2684">&nbsp;</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <ul className="ak-ul" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="2690">The order is automatically turned into an Asana task
                                    and enters the system for further processing.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="2789">Once processing begins, the task will get
                                    the <strong data-renderer-mark="true">&ldquo;in progress&rdquo;</strong> status.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="2865">If the task contains incorrect data or any
                                    additions/changes are needed, everything is discussed in the comments of that
                                    task.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="3003">Next, the order task is reassigned to the office
                                    manager/accountant of the ordered product's location.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="3108">The responsible employee requests an invoice from
                                    the supplier, submits it to the accounting department for payment, and waits for the product to arrive at the office.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="3237">When the equipment arrives at the office, the office
                                    manager notes in the corresponding task that the order is ready for pickup or
                                    shipping, transfers the task to the person who ordered the product (or to the employee receiving the gift, in the case
                                    of gifting), and also moves the order to the <strong
                                        data-renderer-mark="true">&ldquo;delivery&rdquo;</strong> category.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="3513">After the equipment is handed over to the employee,
                                    the office manager moves the task to the <strong
                                        data-renderer-mark="true">&ldquo;done&ldquo;</strong> section and leaves a
                                    corresponding comment in the task.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="3648">After receiving the product, the ordering employee
                                    (or the employee receiving the gift, in the case of gifting) confirms it from their
                                    personal account in Belcoin Shop. The bot then automatically closes the task for the ordered product.</p>
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="3865">Order statuses</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <ul className="ak-ul" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="3886"><strong data-renderer-mark="true">in progress </strong>-
                                    the order is being processed by the project administrator.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="3954"><strong data-renderer-mark="true">delivery</strong> -
                                    the order has been produced and handed over for delivery.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="4008"><strong data-renderer-mark="true">done</strong> -
                                    the order has been handed to the recipient.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="4044"><strong data-renderer-mark="true">canceled</strong> -
                                    the order has been canceled.</p>
                            </li>
                        </ul>
                        <p data-renderer-start-pos="4071">You can track the order status in the generated Asana task
                            and on the shop website in your personal account.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="4180">Can I order a product that is <strong
                            data-renderer-mark="true"><u data-renderer-mark="true">available in another
                            location?</u></strong></p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="4243">Yes, you can place such an order. However, it can only be
                            picked up at the office of the specified country. This option is suitable, for example, if you are planning a business trip
                            to that location.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="4422">When can I place an order?</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="4453">An order can be placed at any time.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="4494">Processing and delivery times</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="4525">Delivery times depend on the product type, your location, and
                            whether the product is currently in stock.</p>
                        <p data-renderer-start-pos="4656"><strong data-renderer-mark="true">Branded
                            merchandise</strong></p>
                        <p data-renderer-start-pos="4679"><u data-renderer-mark="true">If products are in stock</u></p>
                        <p data-renderer-start-pos="4700"><em data-renderer-mark="true">Lithuania</em> &ndash; up to 2 weeks
                        </p>
                        <p data-renderer-start-pos="4721"><em data-renderer-mark="true">Cyprus, Montenegro,
                            Georgia </em>&ndash; up to 2 months (orders are collected during the first month; shipping to
                            locations and customs clearance during the second)</p>
                        <p data-renderer-start-pos="4840"><em data-renderer-mark="true">Belarus</em>- depends on whether
                            there are employees traveling in that direction from Lithuania; exact timelines cannot
                            be given</p>
                        <p data-renderer-start-pos="4981"><em data-renderer-mark="true">Ukraine</em> &ndash; 3-6 weeks
                        </p>
                        <p data-renderer-start-pos="5003"><em data-renderer-mark="true">Poland</em> &ndash; 3-6
                            weeks&nbsp;</p>
                        <p data-renderer-start-pos="5025"><u data-renderer-mark="true">If products are out of stock:</u></p>
                        <ol className="ak-ol" start="1" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="5052">keep in mind that a particular product may
                                    be available in a limited quantity/batch (with no possibility of
                                    re-production).&nbsp;</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5197">the wait time for merch production and delivery
                                    is 2-3 months (if there are no limitations for the batch).</p>
                            </li>
                        </ol>
                        <p data-renderer-start-pos="5307"><strong data-renderer-mark="true">Electronics</strong></p>
                        <p data-renderer-start-pos="5316">Delivery takes 4-6 weeks</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="5367">Delivery</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <ul className="ak-ul" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="5381"><strong data-renderer-mark="true">Lithuania</strong> -
                                    delivery to the office only.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5431"><strong data-renderer-mark="true">Belarus</strong> -
                                    delivery to the office only.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5484"><strong data-renderer-mark="true">Cyprus</strong> -
                                    delivery to the office only.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5533"><strong
                                    data-renderer-mark="true">Montenegro</strong> - delivery to the office
                                    only.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5588"><strong data-renderer-mark="true">Ukraine</strong> -
                                    address delivery is available.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5636"><strong data-renderer-mark="true">Poland</strong> -
                                    address delivery is available.&nbsp;</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5683"><strong data-renderer-mark="true">Georgia</strong> -
                                    delivery to the office only.&nbsp;</p>
                            </li>
                        </ul>
                        <p data-renderer-start-pos="5735">Delivery of orders to <strong data-renderer-mark="true">other
                            countries </strong>is handled by <u data-renderer-mark="true">the employee
                            themselves</u>. To do this, you need to:</p>
                        <ol className="ak-ol" start="1" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="5840">Place an order in a location where delivery
                                    is made to the office.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5911">Wait for the <strong
                                    data-renderer-mark="true">&ldquo;delivery&ldquo;</strong> order status.</p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="5951">Arrange self-pickup of the order from the office,
                                    having agreed on the pickup date and time in advance in the task comments.</p>
                            </li>
                        </ol>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="6087">Can an order be returned or exchanged?</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="6127">Exchanges and returns are not possible (except in cases
                            of defective products).</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="6213">Can an order be modified?</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="6252">An order can be modified while it is in the
                            &ldquo;in progress&rdquo; status.</p>
                        <p data-renderer-start-pos="6328">Once the order has been handed over for delivery, it can
                            no longer be modified.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="6404">Can an order be canceled?</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="6432">There are 2 order cancellation scenarios:</p>
                        <ol className="ak-ol" start="1" data-indent-level="1">
                            <li>
                                <p data-renderer-start-pos="6467">While the order is in the <strong
                                    data-renderer-mark="true">&ldquo;in progress&rdquo;</strong> status, it can be
                                    canceled <strong data-renderer-mark="true">with a refund of BelCoins</strong> to your account.
                                </p>
                            </li>
                            <li>
                                <p data-renderer-start-pos="6563">If the cancellation happens after the order has been
                                    handed over for delivery, <strong data-renderer-mark="true">BelCoins are not
                                        refunded.</strong></p>
                            </li>
                        </ol>
                        <p data-renderer-start-pos="6659">To cancel an order, write about it in the order
                            comments, stating the reason, and wait for a response from the project administrator. After
                            that, the task will be closed.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="6846">Size chart</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="6865">Each item on the site has its own size chart,
                            which can be found on the product page.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="6967">Is monetary compensation for the product's
                            value possible?</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="7035">No, it is not.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="7052">Can accumulated Belcoins be transferred to colleagues?</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="7109">No, they cannot.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="7126">Do accumulated Belcoins expire</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="7161">Belcoins are valid for the entire duration of the
                            employee's employment.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340" data-cell-background="#ffffff">
                        <p data-renderer-start-pos="7228">Can I receive my order after leaving the company?</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="7279">If you are leaving the company and have products ordered
                            in the shop, please let us know in advance in the task comments, and your case
                            will be considered individually.</p>
                    </td>
                </tr>
                <tr>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="4233">Project administrator</p>
                    </td>
                    <td colSpan="1" rowSpan="1" data-colwidth="340">
                        <p data-renderer-start-pos="4258"><a className="css-tgpl01"
                                                             title="https://app.slack.com/client/T7Q18QQ0Y/D02QGF8A1U2/rimeto_profile/U03H9S3NCKT"
                                                             href="https://app.slack.com/client/T7Q18QQ0Y/D02QGF8A1U2/rimeto_profile/U03H9S3NCKT"
                                                             data-renderer-mark="true">Karolina Urbanovic</a></p>
                    </td>
                </tr>
                </tbody>
            </table>
        </Box>
    );
}
